import type { RelatedGridFilter } from '@locus-taxy/entity-detail/grid-adapter';
import { CustomAppRemoteContainer } from './CustomAppRemoteContainer';
import type {
  EntityFrontendPresentation,
  FormSchema,
} from '../components/EntityDetails/types';
import type { CustomDetailsConfig } from './customDetailsConfig';

interface CustomDetailsPageContainerProps {
  config: CustomDetailsConfig;
  clientId?: string;
  entityName?: string;
  entityTitle?: string;
  rootInstanceKey?: string;
  entityData?: Record<string, unknown>;
  detailsForm?: FormSchema;
  showTimeline?: boolean;
  remountKey?: number;
  entitySchemaInfo?: unknown;
  frontend?: EntityFrontendPresentation;
  usecase?: string;
  /** True when mounted from a details-view `custom` section slot rather than
   *  the whole-page custom-app mechanism (DP-5128). */
  embedded?: boolean;
  /** The parent-scope filter resolved from a `custom` section's own join
   *  `path` (DP-5128 Decision 1) — undefined for the whole-page mechanism. */
  parentFilter?: RelatedGridFilter;
}

export function CustomDetailsPageContainer({
  config,
  clientId = '',
  entityName = '',
  entityTitle = '',
  rootInstanceKey,
  entityData = {},
  detailsForm,
  showTimeline = false,
  remountKey = 0,
  entitySchemaInfo,
  frontend,
  usecase,
  embedded,
  parentFilter,
}: Readonly<CustomDetailsPageContainerProps>) {
  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="flex-1 overflow-hidden">
        <CustomAppRemoteContainer
          config={config}
          clientId={clientId}
          entityName={entityName}
          entityTitle={entityTitle}
          rootInstanceKey={rootInstanceKey}
          entityData={entityData}
          detailsForm={detailsForm}
          showTimeline={showTimeline}
          remountKey={remountKey}
          entitySchemaInfo={entitySchemaInfo}
          frontend={frontend}
          usecase={usecase}
          embedded={embedded}
          parentFilter={parentFilter}
        />
      </div>
    </div>
  );
}
